import { Controller } from "@hotwired/stimulus"

// Opening on connect is the only behavior needed: native <dialog> handles the backdrop,
// focus trapping and Esc-to-close itself, and dismissing is the "only going forward"
// answer, so there is nothing to submit.
export default class extends Controller {
  connect() {
    this.element.showModal()
  }
}
